import './modals'
import EventBus from '../wirebox/event-bus'
import jQuery from 'jquery'

class ConfirmationModule {
    
    /**
     * Construct module
    */
    constructor() {
        
        /**
         * Event element jQuery object
         * @type object
        */
        this.element = null
        
        /**
         * Modal container jQuery object
         * @type object
        */
        this.container = null
        
        this.bindEvents()
        
    }
    
    /**
     * Create Confirmation
     * @params params
     */
    createConfirmation({callback = null, element = null, message = 'Are you sure?'} = {}) {
        
        this.callback = callback
        this.element = element
        
        //Open modal
        EventBus.publish('create-modal', {
            body: `<p>${message}</p>`,
            callback: (modal) => {
                this.container = modal
            },
            header: '<p class="h3">Confirmation</p>',
            footer: `
                <button type="button" class="btn btn-link text-dark" data-dismiss="modal">
                    <i aria-hidden="true" class="icon-cancel text-danger"></i>
                    No
                </button>
                <button type="button" class="btn btn-link text-dark confirm">
                    <i aria-hidden="true" class="icon-ok text-success"></i>
                    Yes
                </button>
            `,
            footerClasses: 'bg-light justify-content-between',
            size: 'sm'
        })
        
    }
    
    /**
     * A confirmation form has been submitted
    */
    confirmationFormSubmit(event) {
        
        //Cancel default form submission
        event.preventDefault()
        
        //Get submitted form
        const element = jQuery(event.target)

        //Create confirmation modal
        this.createConfirmation({
            element: element,
            message: element.data('confirm-text')
        })
        
    }
    
    /**
     * Yes button has been clicked
    */
    yesClicked() {
        
        //Hide modal
        this.container.modal('hide')
        
        //Handle callback
        if (typeof this.callback == 'function') {
            this.callback()
            return
        }

        //Default form submission
        EventBus.publish('prepare-form-submit', this.element)
        this.element.removeClass('confirmation-form').submit()
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Form submit
        jQuery(document).on('submit', '.confirmation-form', this.confirmationFormSubmit.bind(this))
        
        //Confirm button click
        .on('click', '.confirm', this.yesClicked.bind(this))
        
        //Show confirmation
        EventBus.subscribe('confirmation.create', this.createConfirmation.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    new ConfirmationModule()
})

export default ConfirmationModule